const REDIRECT_QUERY_PARAM = 'redirect';
const SKIP_REDIRECT_ONCE_KEY = 'skipLoginRedirectOnce';

export const isSafeInternalRedirect = (path) => {
  if (typeof path !== 'string' || path.length === 0) {
    return false;
  }

  // Prevent open redirects to external origins.
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('://')) {
    return false;
  }

  return true;
};

export const buildLoginPathWithRedirect = (location, loginPath = '/login') => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    const shouldSkipRedirectOnce = window.sessionStorage.getItem(SKIP_REDIRECT_ONCE_KEY) === 'true';
    if (shouldSkipRedirectOnce) {
      window.sessionStorage.removeItem(SKIP_REDIRECT_ONCE_KEY);
      return loginPath;
    }
  }

  if (!location || !location.pathname) {
    return loginPath;
  }

  const targetPath = `${location.pathname}${location.search || ''}${location.hash || ''}`;

  if (!isSafeInternalRedirect(targetPath) || targetPath.startsWith(loginPath)) {
    return loginPath;
  }

  const params = new URLSearchParams();
  params.set(REDIRECT_QUERY_PARAM, targetPath);

  return `${loginPath}?${params.toString()}`;
};

export const markExplicitLogoutRedirectDefault = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }

  window.sessionStorage.setItem(SKIP_REDIRECT_ONCE_KEY, 'true');
};

export const getPostLoginRedirectPath = (search, fallbackPath) => {
  const params = new URLSearchParams(search || '');
  const redirectPath = params.get(REDIRECT_QUERY_PARAM);

  if (!isSafeInternalRedirect(redirectPath)) {
    return fallbackPath;
  }

  return redirectPath;
};
